import styled from 'styled-components';
import { colors, Body2 } from 'ui/theme';
import { SelectValueDisplay } from 'ui/selects';
import { ValueDisplay } from 'ui/selects/SelectValueDisplay.styles';

export const DefaultTrigger = styled(SelectValueDisplay)`
  & ${ValueDisplay} {
    width: 50px; /** this is needed for long titles to not overflow for some reason */
    /** truncation for ellipsis */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const FilterSelectSuffix = styled(Body2)`
  color: ${colors.textSecondary};
`;
